export default "__VITE_ASSET__kT3cwhD7__"